// extracted by mini-css-extract-plugin
module.exports = {"Gifts":"Gifts_Gifts__2mQzo","Bubbles":"Gifts_Bubbles__1oUyp","Bubble":"Gifts_Bubble__WQQhy"};